import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const getTitle = (statusParam, alertGroup) => {
  switch (statusParam) {
    case "success":
      return (
        <div className="container d-flex flex-column justify-content-center">
          <div className="row d-flex justify-content-center">
            <i className="fas fa-check-circle fa-3x text-success"></i>
          </div>
          {alertGroup ? (
            <div className="row">
              <div className="col d-flex justify-content-center mt-1">
                <h3 className="text-primary">{alertGroup}</h3>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      );
      break;
    case "warning":
      return (
        <div className="container d-flex flex-column justify-content-center">
          <div className="row d-flex justify-content-center">
            <i className="fas fa-exclamation-triangle fa-3x text-warning"></i>
          </div>
          {alertGroup ? (
            <div className="row">
              <div className="col d-flex justify-content-center mt-1">
                <h3 className="text-primary">{alertGroup}</h3>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      );
      break;
    case "error":
      return (
        <div className="container d-flex flex-column justify-content-center">
          <div className="row d-flex justify-content-center">
            <i className="fas fa-exclamation-circle fa-3x text-danger"></i>
          </div>
          {alertGroup ? (
            <div className="row">
              <div className="col d-flex justify-content-center mt-1">
                <h3 className="text-primary">{alertGroup}</h3>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      );
      break;
    default:
      break;
  }
};

const getText = (messageParam) => {
  return <h3 className="my-2">{messageParam}</h3>;
};
const getText2 = (messageParam) => {
  return (
    <h3 className="my-2">
      {messageParam.map((a, k) => (
        <div>{a}</div>
      ))}
    </h3>
  );
};

const Alert = (
  status,
  message,
  alertGroup,
  { confirm = false, onAfterClose = () => {} } = ""
) => {
  MySwal.fire({
    title: getTitle(status, alertGroup),
    html: getText(message),
    showConfirmButton: confirm,
    allowOutsideClick: !confirm,
    timer: confirm ? undefined : 2000,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: false,
    onAfterClose: onAfterClose,
  });
};
export function confirmedAlert(title, message, callback) {
  MySwal.fire({
    title: title,
    text: message,
    showCancelButton: true,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  }).then((confirmed) => {
    callback(confirmed && confirmed.value == true);
  });
}
export function toast({ status, text, timer = 3000 }) {
  MySwal.fire({
    icon: status,
    title: text,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: timer,
  });
}

export function toastWithExit({ status, header, text }) {
  MySwal.fire({
    icon: status,
    title: header,
    // toast: true,
    html: getText2(text),
    position: "center",
    showConfirmButton: true,
    showCancelButton: false,
    // showCancelButton: false
    // timer: 3000,
  });
}
export default Alert;

export function showLoading(cl) {
  MySwal.fire({
    title: cl,
    allowEscapeKey: false,
    allowOutsideClick: false,
    showCancelButton: false,
    showConfirmButton: false,
    // timer: 2000,
    onOpen: () => {
      MySwal.showLoading();
    },
  }).then(() => {
    console.log(cl);
  });
}
